<template>
    <div class="profile-about-blocks d-flex">

        <div class="profile-about-blocks__item">

            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{user.actual_pets_count || 0}}</span>
                {{$store.getters.t('user_about_current')}} <br> {{$store.getters.t('user_about_wards')}}
            </div>

        </div>

        <div class="profile-about-blocks__item">

            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{user.total_pets_count || 0}}</span>
                {{$store.getters.t('user_about_total')}} <br> {{$store.getters.t('user_about_animals')}}
            </div>

        </div>

        <div class="profile-about-blocks__item">
            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{user.adopted_pets_count || 0}}</span> {{$store.getters.t('user_about_homed')}}
            </div>
        </div>

        <div class="profile-about-blocks__item">
            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{ user.actual_projects_count || 0 }}</span> {{$store.getters.t('user_about_projects')}}
            </div>
        </div>

        <div class="profile-about-blocks__item">
            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">
                    {{+user['donated_by_user']}} USD
                </span>

                {{$store.getters.t('user_about_funds')}} <br> {{$store.getters.t('user_about_sent')}}
            </div>

        </div>

    </div>
</template>

<script>
export default {
    name: "UserAbout",
    props: ['user']
}
</script>

<style scoped>

</style>
